import { Button } from "./ButtonElements";

const CustomButton = ({ children, className, onClick }) => {
  return (
    <Button onClick={onClick} className={className}>
      {children}
    </Button>
  );
};

export default CustomButton;
